import TestCommon from './test-common.vue';
export default TestCommon;